export default "__VITE_ASSET__0da4fc8c__"